import React, { useEffect, useState } from "react";
import axios from "axios";
import { url } from "../../url";
import Loadingcom from "./Loading";

/**
 * صفحه‌ی «در انتظار تایید مدارک» — نسخه‌ی یکدست برای همه‌ی تب‌های راننده.
 *
 * اصل ریسک‌پایین: هیچ منطق business یا ناوبری جدیدی اضافه نمی‌شود.
 * فقط نمایش بهتر + یک دکمه‌ی ریفرش که پروفایل را از سرور می‌خواند و
 * نتیجه را با رویداد marknews به context اصلی می‌فرستد تا همان منطق
 * قبلی (TravelCard و بقیه) وضعیت را دوباره بخوانند.
 */

const REFRESH_INTERVAL_SECONDS = 20;

function PendingApprovalScreen() {
    const [refreshing, setRefreshing] = useState(false);
    const [countdown, setCountdown] = useState(REFRESH_INTERVAL_SECONDS);

    const refreshProfile = async () => {
        if (refreshing) return;
        setRefreshing(true);
        try {
            const token = localStorage.getItem("token");
            if (!token) return;
            await axios.get(`${url}/driver/v1/get-my-profile`, {
                headers: { Authorization: `Bearer ${token}` },
            });
            // context اصلی (App.js) روی تغییر route گوش می‌دهد؛ برای اینکه
            // بدون تغییر route هم وضعیت جدید را بخواند، یک رویداد می‌فرستیم.
            window.dispatchEvent(new CustomEvent("mk:pending-approval-check"));
        } catch (_) {
            // خطای شبکه: چیزی خراب نمی‌شود؛ کاربر می‌تواند دوباره تلاش کند
        } finally {
            setRefreshing(false);
            setCountdown(REFRESH_INTERVAL_SECONDS);
        }
    };

    // شمارش معکوس برای ریفرش خودکار (ملایم، بدون مزاحمت برای کاربر)
    useEffect(() => {
        const timer = setInterval(() => {
            setCountdown((prev) => {
                if (prev <= 1) {
                    refreshProfile();
                    return REFRESH_INTERVAL_SECONDS;
                }
                return prev - 1;
            });
        }, 1000);
        return () => clearInterval(timer);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [refreshing]);

    return (
        <div className="mk-pending-approval w-full h-full flex flex-col items-center justify-center px-6">
            <div className="mk-pending-approval__card mk-fade-in">
                <div className="mk-pending-approval__badge" aria-hidden="true">
                    <svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <circle cx="24" cy="24" r="22" stroke="currentColor" strokeWidth="3" strokeDasharray="6 5" strokeLinecap="round" className="mk-pending-approval__ring" />
                        <path d="M24 14v10l7 4" stroke="currentColor" strokeWidth="3.4" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                </div>

                <h2 className="mk-pending-approval__title">
                    مدارک شما در انتظار تایید است
                </h2>

                <p className="mk-pending-approval__subtitle">
                    اطلاعات و مدارک شما با موفقیت ثبت شد و هم‌اکنون در حال بررسی
                    توسط تیم پشتیبانی است. به‌محض تایید، همه‌ی امکانات اپلیکیشن
                    برای شما فعال می‌شود.
                </p>

                <ul className="mk-pending-approval__steps" dir="rtl">
                    <li className="mk-pending-approval__step is-done">
                        <span className="mk-pending-approval__dot" aria-hidden="true"></span>
                        ثبت مدارک
                    </li>
                    <li className="mk-pending-approval__step is-active">
                        <span className="mk-pending-approval__dot" aria-hidden="true"></span>
                        بررسی توسط پشتیبانی
                    </li>
                    <li className="mk-pending-approval__step">
                        <span className="mk-pending-approval__dot" aria-hidden="true"></span>
                        تایید نهایی و شروع کار
                    </li>
                </ul>

                <button
                    type="button"
                    className="mk-pending-approval__refresh"
                    onClick={refreshProfile}
                    disabled={refreshing}
                >
                    {refreshing ? (
                        <>
                            <Loadingcom />
                            <span>در حال بررسی…</span>
                        </>
                    ) : (
                        <>
                            <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                                <path d="M16.5 10a6.5 6.5 0 1 1-1.9-4.6" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
                                <path d="M16.7 2.8v3.4h-3.4" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                            <span>بررسی وضعیت تایید</span>
                        </>
                    )}
                </button>

                <p className="mk-pending-approval__hint">
                    وضعیت به‌صورت خودکار هم هر {REFRESH_INTERVAL_SECONDS} ثانیه بررسی می‌شود.
                </p>
            </div>
        </div>
    );
}

export default PendingApprovalScreen;
